import { createSlice } from '@reduxjs/toolkit';
import { handleRequestThunk } from '../../../handleRequestThunk';
import { getPartsNoAccount } from '../partsThunks';
import { commonInitialState } from '../../../../../utils/common/commonInitialState';
const SLICE_NAME = 'partsNoAccount';

export const partsNoAccountSlice = createSlice({
    name: SLICE_NAME,
    initialState: structuredClone(commonInitialState),
    extraReducers: (builder) => {
        handleRequestThunk({ builder, request: getPartsNoAccount });
    },
});

export const partsNoAccount = partsNoAccountSlice.reducer;
